import {
	Alert,
	Box,
	Button,
	Grid,
	Paper,
	Typography,
	TableCell,
	TableContainer,
	Table,
	TableBody,
	TableHead,
	TableRow,
	Menu,
	MenuItem,
	Modal,
	Snackbar,
	Tooltip,
	FormControl,
	Select,
	TextField,
	InputAdornment,
} from '@mui/material';
import '../Dashboard.css';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';
import React, { useEffect, useState } from 'react';
import { editVisitData } from '../../../services/api/apiManager';
import PropTypes from 'prop-types';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GridOnIcon from '@mui/icons-material/GridOn';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const finderInputSx = {
	'& .MuiInputBase-root': {
		height: 40,
		borderRadius: '6px',
		background: '#fff',
		fontFamily: 'Poppins',
		fontSize: '13px',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: '#d6e2f2',
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#b9cbe3',
	},
	'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#2f6edb',
		borderWidth: '1px',
	},
	'& .MuiInputBase-input': {
		padding: '9px 12px',
		boxSizing: 'border-box',
	},
};

const finderHeaderSelectSx = {
	height: 40,
	minWidth: 170,
	borderRadius: '6px',
	color: '#fff',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
	background: 'rgba(255, 255, 255, 0.06)',
	'& .MuiSelect-select': {
		padding: '9px 36px 9px 14px',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: 'rgba(255, 255, 255, 0.45)',
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#fff',
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#fff',
		borderWidth: '1px',
	},
	'& .MuiSvgIcon-root': {
		color: '#fff',
	},
};

const finderMenuProps = {
	PaperProps: {
		sx: {
			maxHeight: 280,
			borderRadius: '6px',
			boxShadow: '0 10px 24px rgba(15, 35, 70, 0.18)',
			'& .MuiMenuItem-root': {
				fontFamily: 'Poppins',
				fontSize: '13px',
				minHeight: 36,
			},
		},
	},
};

const exportButtonSx = (tone) => ({
	height: 40,
	borderRadius: '6px',
	textTransform: 'none',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
	px: 2,
	boxShadow: 'none',
	color: tone === 'excel' ? '#16834a' : '#e72d3a',
	borderColor: tone === 'excel' ? '#9fd8bd' : '#f3b2b8',
	background: '#fff',
	'&:hover': {
		borderColor: tone === 'excel' ? '#16834a' : '#e72d3a',
		background: tone === 'excel' ? '#effaf5' : '#fff3f4',
		boxShadow: 'none',
	},
});

function Patients({
	filteredVisits,
	setFilteredVisits,
	visitData,
	loading,
	getDataForAdmittedPatients,
	searchText,
	setSearchText,
	provider,
	location,
	handleProvider,
	handleLocation,
	locations,
	staffList,
	currentPage,
	rowsPerPage,
}) {
	Patients.propTypes = {
		visitData: PropTypes.array.isRequired,
		setVisitData: PropTypes.func.isRequired,
		filteredVisits: PropTypes.array.isRequired,
		setFilteredVisits: PropTypes.func.isRequired,
		loading: PropTypes.bool.isRequired,
		setLoading: PropTypes.func.isRequired,
		searchText: PropTypes.string.isRequired,
		setSearchText: PropTypes.func.isRequired,
		getVisitData: PropTypes.func.isRequired,
		getDataForAdmittedPatients: PropTypes.func.isRequired,
		provider: PropTypes.string.isRequired,
		location: PropTypes.string.isRequired,
		handleProvider: PropTypes.func.isRequired,
		handleLocation: PropTypes.func.isRequired,
		locations: PropTypes.array.isRequired,
		staffList: PropTypes.array.isRequired,
		currentPage: PropTypes.number.isRequired,
		rowsPerPage: PropTypes.number.isRequired,
	};

	// Modal
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 450,
		bgcolor: 'background.paper',
		border: '2px solid #000',
		borderRadius: '1rem',
		boxShadow: 24,
		p: 4,
	};

	const navigate = useNavigate();
	const [currentDate, setCurrentDate] = useState(new Date());
	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedVisitId, setSelectedVisitId] = useState(null);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [openSnackbarDelete, setOpenSnackbarDelete] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [deleteId, setDeleteId] = useState();
	const handleOpenDeleteModal = (dID) => {
		setDeleteId(dID);
		setOpenDeleteModal(true);
	};
	const handleCloseDeleteModal = () => {
		setOpenDeleteModal(false);
		handleMenuClose();
	};

	// open snakbar delete
	const handleClickSnackbarDelete = () => {
		setOpenSnackbarDelete(true);
	};
	const handleCloseSnackbarDelete = () => {
		setOpenSnackbarDelete(false);
	};

	console.log('Current Date' + currentDate);

	const theme = {
		palette: {
			primary: {
				main: '#D7DBDD',
				light: '#6ec6ff',
			},
		},
		spacing: (factor) => `${8 * factor}px`,
	};

	const handleSearch = () => {
		if (searchText.trim() === '') {
			getDataForAdmittedPatients();
		} else {
			const filteredData = visitData?.filter((item) =>
				item?.Name?.toLowerCase().includes(searchText?.toLowerCase())
			);
			setFilteredVisits(filteredData);
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			handleSearch();
		}
	};

	const getWeekDates = (date) => {
		const currentDay = date.getDay();
		const firstDayOfWeek = new Date(date);
		firstDayOfWeek.setDate(firstDayOfWeek.getDate() - currentDay);
		const weekDates = [...Array(7)].map((_, index) => {
			const date = new Date(firstDayOfWeek);
			date.setDate(date.getDate() + index);
			return date;
		});
		return weekDates;
	};

	const getAbbreviatedDayOfWeek = (date) => {
		const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		return daysOfWeek[date.getDay()];
	};

	const formatDate = (date) => {
		const monthNames = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];
		const month = monthNames[date.getMonth()];
		const year = date.getFullYear();
		return `W${getWeekNumber(date)} - ${month} ${year}`;
	};

	const getWeekNumber = (date) => {
		const oneJan = new Date(date.getFullYear(), 0, 1);
		const numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));
		const weekNumber = Math.ceil((date.getDay() + 1 + numberOfDays) / 7);
		return weekNumber;
	};

	const handleNextWeek = () => {
		const nextWeek = new Date(currentDate);
		nextWeek.setDate(nextWeek.getDate() + 7);
		setCurrentDate(nextWeek);
	};

	const handlePreviousWeek = () => {
		const previousWeek = new Date(currentDate);
		previousWeek.setDate(previousWeek.getDate() - 7);
		setCurrentDate(previousWeek);
	};

	const handleMenuOpen = (event, visitId) => {
		setAnchorEl(event.currentTarget);
		setSelectedVisitId(visitId);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleEditButton = () => {
		navigate('/editCharge', { state: { visit_ID: selectedVisitId } });
	};

	const getInitials = (name = '') =>
		name
			.split(/[\s,]+/)
			.filter(Boolean)
			.slice(0, 2)
			.map((part) => part.charAt(0).toUpperCase())
			.join('') || 'P';

	const formatShortDate = (dateValue) => {
		if (!dateValue) return '-';
		const date = new Date(dateValue);
		if (Number.isNaN(date.getTime())) return '-';
		return date.toLocaleDateString('en-US', {
			month: 'short',
			day: '2-digit',
			year: 'numeric',
		});
	};

	const getShortMonth = (date) =>
		date.toLocaleString('en-US', {
			month: 'short',
		});

	const renderCellPill = (content) => {
		if (!content) return null;
		const colorMap = {
			Gap: { color: '#d92424', bg: '#fff1f1', border: '#ffcaca' },
			Admitted: { color: '#1b5ac7', bg: '#edf4ff', border: '#cfe0ff' },
			Visit: { color: '#078a37', bg: '#edfff4', border: '#c8f0d5' },
			Discharged: { color: '#b87800', bg: '#fff8e5', border: '#f4dc98' },
		};
		const tone = colorMap[content] || {
			color: '#0b2450',
			bg: '#f5f8fd',
			border: '#dbe7f5',
		};
		return (
			<Box
				component="span"
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					minWidth: 52,
					height: 24,
					px: 1.5,
					borderRadius: '6px',
					border: `1px solid ${tone.border}`,
					background: tone.bg,
					color: tone.color,
					fontFamily: 'Poppins',
					fontSize: '12px',
					fontWeight: 600,
				}}
			>
				{content}
			</Box>
		);
	};

	const table = (
		<TableContainer
			component={Paper}
			sx={{
				boxShadow: 'none',
				border: '1px solid #e1eaf5',
				borderRadius: '6px',
				overflow: 'auto',
				maxHeight: 'calc(100vh - 260px)',
			}}
		>
			<Table stickyHeader sx={{ minWidth: 1180, tableLayout: 'fixed' }}>
				<TableHead>
					<TableRow>
						<TableCell
							sx={{
								width: 360,
								background: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								color: '#1e2b45',
								borderBottom: '1px solid #e1eaf5',
								py: 1.5,
								px: 2,
							}}
						>
							Patient Details
						</TableCell>
						{getWeekDates(currentDate).map((date, index) => (
							<TableCell
								key={index}
								sx={{
									width: 150,
									textAlign: 'center',
									background: '#fff',
									fontFamily: 'Poppins',
									color: '#1e2b45',
									borderBottom: '1px solid #e1eaf5',
									py: 1.2,
									px: 1,
								}}
							>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '13px',
										fontWeight: 700,
										lineHeight: 1.2,
									}}
								>
									{getAbbreviatedDayOfWeek(date)} / {date.getDate()}
								</Typography>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '12px',
										color: '#4d5d75',
										lineHeight: 1.2,
									}}
								>
									{getShortMonth(date)}
								</Typography>
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{filteredVisits
						?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
						?.map((item) => {
							return (
								<TableRow
									key={item?.patient_id}
									sx={{
										'& .MuiTableCell-root': {
											borderColor: '#e7edf5',
										},
									}}
								>
									<TableCell sx={{ width: 360, p: 1.25 }}>
										<Box
											sx={{
												display: 'grid',
												gridTemplateColumns: '40px 1fr 18px',
												gap: '10px',
												alignItems: 'center',
												minHeight: 48,
											}}
										>
											<Box
												sx={{
													width: 34,
													height: 34,
													borderRadius: '50%',
													background: '#eef4ff',
													color: '#2f6edb',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													fontFamily: 'Poppins',
													fontSize: '12px',
													fontWeight: 600,
												}}
											>
												{getInitials(item?.Name)}
											</Box>
											<Box sx={{ minWidth: 0 }}>
												<Box
													sx={{
														display: 'flex',
														alignItems: 'center',
														gap: '6px',
														minWidth: 0,
													}}
												>
													<Typography
														sx={{
															fontFamily: 'Poppins',
															color: '#075ad7',
															fontSize: '12px',
															fontWeight: 600,
															whiteSpace: 'nowrap',
															textOverflow: 'ellipsis',
															overflow: 'hidden',
															maxWidth: 150,
														}}
													>
														{item?.Name || '-'}
													</Typography>
													<Box
														component="span"
														sx={{
															borderRadius: '999px',
															px: '6px',
															py: '1px',
															fontFamily: 'Poppins',
															fontSize: '10px',
															fontWeight: 600,
															color:
																item?.Inactive === null ||
																item?.Inactive === false
																	? '#198c37'
																	: '#ef3d3d',
															background:
																item?.Inactive === null ||
																item?.Inactive === false
																	? '#eaf8ef'
																	: '#ffeaea',
														}}
													>
														{item?.Inactive === null || item?.Inactive === false
															? 'Active'
															: 'Inactive'}
													</Box>
												</Box>
												<Box
													sx={{
														display: 'grid',
														gridTemplateColumns: '1fr 1fr',
														gap: '0 10px',
														mt: 0.25,
													}}
												>
													<Typography
														sx={{
															fontFamily: 'Poppins',
															fontSize: '10px',
															fontWeight: 600,
															color: '#1e2b45',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
														}}
													>
														DOB:{' '}
														<Box component="span" sx={{ fontWeight: 500 }}>
															{formatShortDate(item?.DOB)}
														</Box>
													</Typography>
													<Typography
														sx={{
															fontFamily: 'Poppins',
															fontSize: '10px',
															fontWeight: 600,
															color: '#1e2b45',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
														}}
													>
														MRN# {item?.MRN || '-'}
													</Typography>
													<Typography
														sx={{
															fontFamily: 'Poppins',
															fontSize: '10px',
															fontWeight: 600,
															color: '#1e2b45',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
														}}
													>
														Provider Name:{' '}
														<Box component="span" sx={{ fontWeight: 500 }}>
															{item?.provider || '-'}
														</Box>
													</Typography>
													<Typography
														sx={{
															fontFamily: 'Poppins',
															fontSize: '10px',
															fontWeight: 600,
															color: '#1e2b45',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
														}}
													>
														Location:{' '}
														<Box component="span" sx={{ fontWeight: 500 }}>
															{item?.location || '-'}
														</Box>
													</Typography>
													<Typography
														sx={{
															gridColumn: '1 / -1',
															fontFamily: 'Poppins',
															fontSize: '10px',
															fontWeight: 600,
															color: '#1e2b45',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
														}}
													>
														Adm Date:{' '}
														<Box component="span" sx={{ fontWeight: 500 }}>
															{formatShortDate(item?.Admission_date)}
														</Box>
													</Typography>
												</Box>
											</Box>
											<KeyboardArrowRightIcon
												sx={{ color: '#6d7b91', fontSize: 20 }}
											/>
										</Box>
									</TableCell>
									{getWeekDates(currentDate).map((date, index) => {
										const formattedDate = date?.toISOString()?.split('T')[0];
										const isVisit = item?.visits?.some(
											(visit) =>
												visit?.VisitDate?.split('T')[0] === formattedDate
										);
										const visit = item?.visits?.find(
											(visit) =>
												visit?.VisitDate?.split('T')[0] === formattedDate
										);
										const isAdmitted =
											item?.Admission_date?.split('T')[0] === formattedDate;
										const isDischarged =
											item?.discharge_date?.split('T')[0] === formattedDate;
										const isPastDate =
											new Date(formattedDate) < new Date().setHours(0, 0, 0, 0);
										const startDate =
											new Date(formattedDate) >
											new Date(item?.Admission_date).setHours(0, 0, 0, 0);
										const discharged =
											new Date(formattedDate) >
											new Date(item?.discharge_date).setHours(0, 0, 0, 0);
										let isGapText = true;
										let content;
										if (isVisit) {
											content = 'Visit';
										} else if (isAdmitted) {
											content = 'Admitted';
										} else if (isDischarged) {
											content = 'Discharged';
										} else if (isAdmitted && isVisit) {
											content = 'Admitted/Visit';
										} else {
											if (isGapText && startDate && discharged && isPastDate) {
												content = 'Gap';
											} else {
												content = '';
											}
										}
										return (
											<TableCell
												key={index}
												sx={{
													border: '1px solid #e7edf5',
													height: 62,
													p: 1,
													textAlign: 'center',
													cursor:
														content == 'Visit' ||
														content == 'Gap' ||
														content == 'Admitted'
															? 'pointer'
															: '',
													backgroundColor:
														content == 'Admitted'
															? '#f2f6ff'
															: content == 'Visit'
																? '#f2fff7'
																: content == 'Discharged'
																	? '#fffaf0'
																	: content == 'Gap'
																		? '#fff3f3'
																		: '',
												}}
												onClick={
													isVisit
														? (event) => handleMenuOpen(event, visit?.id)
														: (isGapText && content == 'Gap') ||
															  content == 'Admitted'
															? () =>
																	navigate('/newCharge', {
																		state: {
																			patient_id: item?.patient_id,
																			visit_date: date?.toISOString(),
																		},
																	})
															: null
												}
											>
												{content === 'Gap' || content === 'Admitted' ? (
													<Tooltip title="Add Charge">
														<span>{renderCellPill(content)}</span>
													</Tooltip>
												) : (
													renderCellPill(content)
												)}
												<Menu
													anchorEl={anchorEl}
													open={Boolean(
														anchorEl && selectedVisitId == visit?.id
													)}
													onClose={handleMenuClose}
													elevation={1}
													PaperProps={{
														sx: {
															borderRadius: '6px',
															boxShadow: '0 10px 24px rgba(15, 35, 70, 0.18)',
															'& .MuiMenuItem-root': {
																fontFamily: 'Poppins',
																fontSize: '13px',
																minHeight: 34,
															},
														},
													}}
												>
													<MenuItem onClick={handleEditButton}>Edit</MenuItem>
													<MenuItem
														onClick={() => handleOpenDeleteModal(visit?.id)}
													>
														Delete
													</MenuItem>
												</Menu>
											</TableCell>
										);
									})}
								</TableRow>
							);
						})}
				</TableBody>
			</Table>
		</TableContainer>
	);

	const handleDeleteUser = async (id, data) => {
		const response = await editVisitData(id, data);
		if (response.status === 200) {
			setPostSucessfully(true);
			getDataForAdmittedPatients();
			handleMenuClose();
		} else {
			setPostSucessfully(false);
		}
		setOpenDeleteModal(false);
		handleClickSnackbarDelete();
	};

	// Update discharged status of patients
	useEffect(() => {
		filteredVisits?.forEach((date) => {
			if (
				date?.discharge_date &&
				new Date(date?.discharge_date) <= currentDate
			) {
				date.discharged = true;
			}
		});
	}, [currentDate]);

	const mappingProviderList =
		staffList &&
		staffList?.map((row) => ({
			name: row.Lname + ' , ' + row.Fname,
			providerId: row.id,
		}));

	useEffect(() => {
		const handleClick = (event) => {
			if (anchorEl && !anchorEl.contains(event.target)) {
				handleMenuClose();
			}
		};

		document.body.addEventListener('click', handleClick);

		return () => {
			document.body.removeEventListener('click', handleClick);
		};
	}, [anchorEl]);

	return (
		<Grid
			container
			item
			xs={12}
			sm={12}
			md={12}
			lg={12}
			xl={12}
			sx={{ border: 'none', background: '#fff' }}
		>
			<Grid
				container
				item
				xs={12}
				sx={{
					minHeight: 58,
					padding: '8px 16px',
					background: '#124a9a',
					backgroundImage: 'linear-gradient(90deg, #1554ad 0%, #0f3f87 100%)',
					fontFamily: 'Poppins',
					color: 'white',
					display: 'grid',
					gridTemplateColumns: { xs: '1fr', md: '260px 1fr auto' },
					alignItems: 'center',
					gap: '12px',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
					<PeopleAltIcon sx={{ fontSize: 24 }} />
					<Typography
						sx={{ fontFamily: 'Poppins', fontSize: '16px', fontWeight: 700 }}
					>
						Patients
					</Typography>
				</Box>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '14px',
					}}
				>
					<ArrowBackIosNewIcon
						onClick={handlePreviousWeek}
						sx={{ cursor: 'pointer', fontSize: 18 }}
					/>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
						<CalendarMonthIcon sx={{ fontSize: 20 }} />
						<Typography
							sx={{ fontFamily: 'Poppins', fontSize: '15px', fontWeight: 700 }}
						>
							{formatDate(currentDate)}
						</Typography>
					</Box>
					<ArrowForwardIosIcon
						onClick={handleNextWeek}
						sx={{ cursor: 'pointer', fontSize: 18 }}
					/>
				</Box>
				<Box sx={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
					<FormControl size="small">
						<Select
							value={provider}
							onChange={handleProvider}
							displayEmpty
							sx={finderHeaderSelectSx}
							MenuProps={finderMenuProps}
						>
							<MenuItem value="">Provider</MenuItem>
							{mappingProviderList &&
								mappingProviderList.length > 0 &&
								mappingProviderList.map((pl, index) => (
									<MenuItem key={index} value={pl.providerId}>
										{pl?.name}
									</MenuItem>
								))}
						</Select>
					</FormControl>
					<FormControl size="small">
						<Select
							value={location}
							onChange={handleLocation}
							displayEmpty
							sx={finderHeaderSelectSx}
							MenuProps={finderMenuProps}
						>
							<MenuItem value="">Location</MenuItem>
							{locations?.map((items, index) => {
								return (
									<MenuItem key={index} value={items?.id}>
										{items?.Name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Box>
			</Grid>

			<Grid
				item
				xs={12}
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: '12px',
					flexWrap: 'wrap',
					padding: '14px 18px',
					background: '#fff',
				}}
			>
				<Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
					<TextField
						size="small"
						placeholder="Search by Patient Name"
						sx={{ ...finderInputSx, width: { xs: '100%', sm: 310 } }}
						value={searchText}
						onChange={(e) => setSearchText(e.target.value)}
						onKeyDown={handleKeyPress}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon sx={{ color: '#7184a3', fontSize: 20 }} />
								</InputAdornment>
							),
						}}
					/>
					<Button
						size="small"
						onClick={handleSearch}
						sx={{
							height: 40,
							minWidth: 86,
							fontFamily: 'Poppins',
							color: 'white',
							background: '#2e68d2',
							border: '1px solid #2e68d2',
							borderRadius: '6px',
							fontSize: '13px',
							fontWeight: 600,
							textTransform: 'none',
							boxShadow: 'none',
							'&:hover': {
								border: '1px solid #2e68d2',
								color: '#2e68d2',
								background: '#f3f7ff',
								boxShadow: 'none',
							},
						}}
					>
						Search
					</Button>
				</Box>
			</Grid>

			{loading ? (
				<BrandedLoader
					title="Loading patients"
					text="Preparing missed charge patients"
				/>
			) : (
				<Grid
					item
					container
					xs={12}
					sm={12}
					md={12}
					lg={12}
					xl={12}
					sx={{
						background: '#fff',
						padding: '0 18px 12px',
					}}
				>
					<Box sx={{ width: '100%' }}>
						{filteredVisits && filteredVisits.length <= 0 ? (
							<Typography
								sx={{
									width: '100%',
									minHeight: 260,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									color: '#7184a3',
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: 600,
								}}
							>
								No Records
							</Typography>
						) : (
							table
						)}
					</Box>
				</Grid>
			)}
			{/* Modal Delete visit */}
			<Modal
				open={openDeleteModal}
				onClose={handleCloseDeleteModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box display={'flex'} flexDirection={'column'} gap={'1rem'}>
						<Typography
							id="modal-modal-title"
							variant="h6"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Are You Sure To Delete Visit?
						</Typography>
						<Box display={'flex'} justifyContent={'center'} gap={'14px'}>
							<Button
								variant="contained"
								sx={{ bgcolor: '#ED2828', width: '130px', py: '10px' }}
								onClick={handleCloseDeleteModal}
							>
								Cancel
							</Button>
							<Button
								variant="contained"
								sx={{ bgcolor: '#FD7702', width: '130px', py: '10px' }}
								onClick={() => {
									handleDeleteUser(deleteId, { Deleted: true });
								}}
							>
								Delete
							</Button>
						</Box>
					</Box>
				</Box>
			</Modal>
			<Snackbar
				open={openSnackbarDelete}
				autoHideDuration={2000}
				onClose={handleCloseSnackbarDelete}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbarDelete}
					severity={!postSucessfully ? 'error' : 'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={handleCloseSnackbarDelete}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{!postSucessfully ? 'Error' : 'Delete Charge Successfully!'}
				</Alert>
			</Snackbar>
		</Grid>
	);
}

export default Patients;
